import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-text',
  templateUrl: './intro-text.component.html',
  styleUrls: ['./intro-text.component.css']
})
export class IntroTextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
